import React, { forwardRef } from 'react';
import { SvgIconProps as MUISvgIconProps } from '@material-ui/core/SvgIcon';

import Add from '@material-ui/icons/Add';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ArrowDropDownRounded from '@material-ui/icons/ArrowDropDownRounded';
import ArrowDropUpRounded from '@material-ui/icons/ArrowDropUpRounded';
import ArrowForward from '@material-ui/icons/ArrowForward';
import ArrowRightAlt from '@material-ui/icons/ArrowRightAlt';
import CameraAlt from '@material-ui/icons/CameraAlt';
import ChatOutlined from '@material-ui/icons/ChatOutlined';
import Cancel from '@material-ui/icons/Cancel';
import Check from '@material-ui/icons/Check';
import CheckBox from '@material-ui/icons/CheckBox';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Clear from '@material-ui/icons/Clear';
import Close from '@material-ui/icons/Close';
import CloudDownload from '@material-ui/icons/CloudDownload';
import CloudUpload from '@material-ui/icons//CloudUpload';
import Computer from '@material-ui/icons/Computer';
import CreditCard from '@material-ui/icons/CreditCard';
import Crop from '@material-ui/icons/Crop';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import DeleteOutlineOutlined from '@material-ui/icons/DeleteOutlineOutlined';
import Description from '@material-ui/icons/Description';
import DescriptionOutlined from '@material-ui/icons/DescriptionOutlined';
import DonutSmallIcon from '@material-ui/icons/DonutSmall';
import DragIndicator from '@material-ui/icons/DragIndicator';
import Edit from '@material-ui/icons/Edit';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import ExpandMore from '@material-ui/icons/ExpandMore';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import FirstPage from '@material-ui/icons/FirstPage';
import Folder from '@material-ui/icons/Folder';
import FormatBold from '@material-ui/icons/FormatBold';
import FormatColorFill from '@material-ui/icons/FormatColorFill';
import FormatItalic from '@material-ui/icons/FormatItalic';
import FormatListNumberedRtl from '@material-ui/icons//FormatListNumberedRtl';
import FormatQuote from '@material-ui/icons/FormatQuote';
import FormatUnderlined from '@material-ui/icons/FormatUnderlined';
import GetApp from '@material-ui/icons/GetApp';
import Help from '@material-ui/icons/Help';
import HelpOutline from '@material-ui/icons/HelpOutline';
import History from '@material-ui/icons/History';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import IndeterminateCheckBoxOutlined from '@material-ui/icons/IndeterminateCheckBoxOutlined';
import Info from '@material-ui/icons/Info';
import Input from '@material-ui/icons/Input';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import LabelImportant from '@material-ui/icons/LabelImportant';
import Language from '@material-ui/icons/Language';
import LastPage from '@material-ui/icons/LastPage';
import Link from '@material-ui/icons/Link';
import List from '@material-ui/icons/List';
import ListAlt from '@material-ui/icons/ListAlt';
import Lock from '@material-ui/icons/Lock';
import LockOutlined from '@material-ui/icons/LockOutlined';
import LaunchOutlined from '@material-ui/icons/LaunchOutlined';
import LowPriority from '@material-ui/icons/LowPriority';
import LocalOfferOutlined from '@material-ui/icons/LocalOfferOutlined';
import LocalPrintshopOutlined from '@material-ui/icons/LocalPrintshopOutlined';
import Menu from '@material-ui/icons/Menu';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import NavigateBefore from '@material-ui/icons/NavigateBefore';
import NavigateNext from '@material-ui/icons/NavigateNext';
import NotInterested from '@material-ui/icons/NotInterested';
import OpenInNew from '@material-ui/icons/OpenInNew';
import Person from '@material-ui/icons/Person';
import PhoneIphone from '@material-ui/icons/PhoneIphone';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import PostAdd from '@material-ui/icons/PostAdd';
import RadioButtonChecked from '@material-ui/icons/RadioButtonChecked';
import Redeem from '@material-ui/icons/Redeem';
import Refresh from '@material-ui/icons/Refresh';
import RemoveCircleOutline from '@material-ui/icons/RemoveCircleOutline';
import ReportProblemRounded from '@material-ui/icons/ReportProblemRounded';
import Schedule from '@material-ui/icons/Schedule';
import Search from '@material-ui/icons/Search';
import Settings from '@material-ui/icons/Settings';
import SettingsOutlined from '@material-ui/icons/SettingsOutlined';
import SmsOutlined from '@material-ui/icons/SmsOutlined';
import Sort from '@material-ui/icons/Sort';
import Star from '@material-ui/icons//Star';
import SwapVertIcon from '@material-ui/icons/SwapVert';
import TabletMac from '@material-ui/icons/TabletMac';
import TextFields from '@material-ui/icons//TextFields';
import Title from '@material-ui/icons//Title';
import Tune from '@material-ui/icons/Tune';
import VerifiedUser from '@material-ui/icons/VerifiedUser';
import ViewDayOutlined from '@material-ui/icons/ViewDayOutlined';
import ViewListRounded from '@material-ui/icons//ViewListRounded';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import VisibilityOutlined from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlined from '@material-ui/icons/VisibilityOffOutlined';
import WatchLater from '@material-ui/icons/WatchLater';
import WebAsset from '@material-ui/icons/WebAsset';
import Warning from '@material-ui/icons/Warning';

import {
  Advertisement,
  ArrowSort,
  ArrowSortAsc,
  ArrowSortDesc,
  BarChart,
  CardboardBox,
  CheckFile,
  Collapse,
  Combine,
  Copy,
  Coupon,
  ConflictRoute,
  CurlyBrackets,
  Design,
  DisplayLogic,
  ExpandAll,
  ExportSheet,
  Facebook,
  FilterAlt,
  FolderSharedMultiple,
  Google,
  Image,
  Logic,
  MailForward,
  Maximum,
  NewReleaseCheck,
  None,
  PieChart,
  Privacy,
  Quiz,
  RadarChart,
  Randomize,
  ShieldError,
  ShieldStar,
  ShieldSuccess,
  ShieldWarning,
  ShortText,
  Skip,
  UploadFile,
  UserReply,
  Video,
  /**
   * 下列客製化 icon 只出現在 @material-ui/icons >= 5，因此未來升級請務必將它刪除，並改 import 原生的 icon
   */
  ArrowCircleDown,
  AutoAwesome,
  AutoAwesomeOutlined,
  CalendarMonth,
  InsertPageBreakOutlined,
  IntegrationInstructionsOutlined,
  LocalFireDepartmentOutlined,
  PinOutlined,
  /**
   * 為了暫時讓編輯題目與統計圖表題目 icon 一致，
   * 故建立舊的題目 icon，待編輯題目開始重構時，再將其替換掉
   */
  TypeChoiceMulti,
  TypeChoiceOne,
  TypeConstantSum,
  TypeDatePicker,
  TypeDigitInput,
  TypeDigitSlide,
  TypeDivider,
  TypeFileUpload,
  TypeItemSort,
  TypeNest,
  TypeNestMulti,
  TypeNestedDropdown,
  TypeNPS,
  TypePickFrom,
  TypeQuote,
  TypeRatingBar,
  TypeStatement,
  TypeTxtLong,
  TypeTxtShort,
  TypeVariableNumber,
  TableList,
  /**
   * credit card issuer associations
   */
  JCB,
  Mastercard,
  Visa,
  /**
   * template recommend issuer associations
   */
  GroupPurchaseAndOrderForm,
  MarketResearch,
  Raffle,
  AcademicSurvey,
  PerformanceAssessment,
  Voting,
  Others,
  CustomerService,
  EventParticipationAndFeedback,
  StatisticsAndRecords,
  PersonalDataCollection,
  WeddingApplication,
  CrowdfundingAndPreTesting,
  SatisfactionSurvey,
  OnlineTestsAndInteractiveActivities,
  CourseParticipationAndFeedback,
  DiningExperienceAndFeedback,
} from './Customize';

export const Icons = {
  AcademicSurvey,
  Add,
  AddCircleOutline,
  Advertisement,
  ArrowBack,
  ArrowCircleDown,
  ArrowDownward,
  ArrowDropDownRounded,
  ArrowDropUpRounded,
  ArrowForward,
  ArrowRightAlt,
  ArrowSort,
  ArrowSortAsc,
  ArrowSortDesc,
  AutoAwesome,
  AutoAwesomeOutlined,
  BarChart,
  CalendarMonth,
  CameraAlt,
  Cancel,
  CardboardBox,
  ChatOutlined,
  Check,
  CheckBox,
  CheckCircle,
  CheckFile,
  Clear,
  Close,
  CloudDownload,
  CloudUpload,
  Collapse,
  Combine,
  Computer,
  ConflictRoute,
  Copy,
  Coupon,
  CourseParticipationAndFeedback,
  CreditCard,
  Crop,
  CrowdfundingAndPreTesting,
  CurlyBrackets,
  CustomerService,
  DeleteOutline,
  DeleteOutlineOutlined,
  Description,
  DescriptionOutlined,
  Design,
  DiningExperienceAndFeedback,
  DisplayLogic,
  DonutSmallIcon,
  DragIndicator,
  Edit,
  ErrorOutline,
  EventParticipationAndFeedback,
  ExpandAll,
  ExpandMore,
  ExportSheet,
  Facebook,
  FileCopyOutlinedIcon,
  FilterAlt,
  FirstPage,
  Folder,
  FolderSharedMultiple,
  FormatBold,
  FormatColorFill,
  FormatItalic,
  FormatListNumberedRtl,
  FormatQuote,
  FormatUnderlined,
  GetApp,
  Google,
  GroupPurchaseAndOrderForm,
  Help,
  HelpOutline,
  HighlightOffIcon,
  History,
  Image,
  IndeterminateCheckBoxOutlined,
  Info,
  Input,
  InsertPageBreakOutlined,
  IntegrationInstructionsOutlined,
  JCB,
  KeyboardArrowDown,
  KeyboardArrowUp,
  LabelImportant,
  Language,
  LastPage,
  LaunchOutlined,
  Link,
  List,
  ListAlt,
  LocalFireDepartmentOutlined,
  LocalOfferOutlined,
  LocalPrintshopOutlined,
  Lock,
  LockOutlined,
  Logic,
  LowPriority,
  MailForward,
  MarketResearch,
  Mastercard,
  Maximum,
  Menu,
  MoreHoriz,
  NavigateBefore,
  NavigateNext,
  NewReleaseCheck,
  None,
  NotInterested,
  OnlineTestsAndInteractiveActivities,
  OpenInNew,
  Others,
  PerformanceAssessment,
  Person,
  PersonalDataCollection,
  PhoneIphone,
  PictureAsPdf,
  PieChart,
  PinOutlined,
  PostAdd,
  Privacy,
  Quiz,
  RadarChart,
  RadioButtonChecked,
  Raffle,
  Randomize,
  Redeem,
  Refresh,
  RemoveCircleOutline,
  ReportProblemRounded,
  SatisfactionSurvey,
  Schedule,
  Search,
  Settings,
  SettingsOutlined,
  ShieldError,
  ShieldStar,
  ShieldSuccess,
  ShieldWarning,
  ShortText,
  Skip,
  SmsOutlined,
  Sort,
  Star,
  StatisticsAndRecords,
  SwapVertIcon,
  TableList,
  TabletMac,
  TextFields,
  Title,
  Tune,
  TypeChoiceMulti,
  TypeChoiceOne,
  TypeConstantSum,
  TypeDatePicker,
  TypeDigitInput,
  TypeDigitSlide,
  TypeDivider,
  TypeFileUpload,
  TypeItemSort,
  TypeNPS,
  TypeNest,
  TypeNestMulti,
  TypeNestedDropdown,
  TypePickFrom,
  TypeQuote,
  TypeRatingBar,
  TypeStatement,
  TypeTxtLong,
  TypeTxtShort,
  TypeVariableNumber,
  UploadFile,
  UserReply,
  VerifiedUser,
  Video,
  ViewDayOutlined,
  ViewListRounded,
  Visa,
  Visibility,
  VisibilityOff,
  VisibilityOffOutlined,
  VisibilityOutlined,
  Voting,
  Warning,
  WatchLater,
  WebAsset,
  WeddingApplication,
};

type Name = keyof typeof Icons;

interface IconProps extends MUISvgIconProps {
  /**
   * Icon name to be rendered
   */
  name: Name;
}

const Icon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  const { name, ...rest } = props;

  const RenderIcon = Icons[name];

  return <RenderIcon {...rest} ref={ref} />;
});

Icon.displayName = 'Icon';

export default Icon;
